












































import 'reflect-metadata'
import { Vue, Component, Prop } from 'vue-property-decorator'
import Tooltip from '@/components/rows/Tooltip.vue'
import BalanceRow from '@/components/Address/BalanceRow.vue'
import { IBalanceX } from '@/services/addresses/models'

@Component({
    components: {
        Tooltip,
        BalanceRow,
    },
})
export default class BalanceTable extends Vue {
    @Prop() assets!: IBalanceX[]
}
